import type { CanHolder } from "../../lib/access";
import type { SetLegalHoldRequest } from "./api";
import { canManageLegalHold } from "./permissions";

/** GR-004: the legal-hold Begruendung must carry at least 10 characters. */
export const MIN_LEGAL_HOLD_REASON_CHARS = 10;

/** Submit-enable check for the set-legal-hold dialog (min length after trim). */
export function isLegalHoldReasonValid(reason: string): boolean {
  return reason.trim().length >= MIN_LEGAL_HOLD_REASON_CHARS;
}

/**
 * The header controls (set/clear) show when the incident's `can` holds
 * `incident.legal-hold`; the badge itself is visible to everyone. The server
 * re-checks (ADR-API-09).
 */
export function isLegalHoldActionVisible(incident: CanHolder): boolean {
  return canManageLegalHold(incident);
}

/** Build the PUT body (trimmed Begruendung). */
export function buildSetLegalHoldRequest(reason: string): SetLegalHoldRequest {
  return { reason: reason.trim() };
}
